export function Language({ lang, change }) {
  return (
    <div className="language" data-testid="language-switcher">
      <button className={lang === "fa" ? "active" : ""} onClick={() => change("fa")} data-testid="language-persian-button">فارسی</button>
      <span>|</span>
      <button className={lang === "en" ? "active" : ""} onClick={() => change("en")} data-testid="language-english-button">English</button>
    </div>
  );
}

export function Logo({ t }) {
  return <div className="logo" data-testid="noorin-logo"><span>{t.brand}</span><small>{t.logoMark || "Strategic clarity"}</small></div>;
}

export function PageTitle({ eyebrow, title, sub, children }) {
  return (
    <div className="page-title page-title-row">
      <div><p className="eyebrow">{eyebrow}</p><h2>{title}</h2>{sub && <p>{sub}</p>}</div>
      {children && <div className="page-title-actions">{children}</div>}
    </div>
  );
}
